import { QuerySnippetsParams } from './types';

export const snippetsKeys = {
  snippets: (params?: QuerySnippetsParams) => ['SNIPPETS', params] as const,
  single_snippet: (snippetId: string) => ['SINGLE_SNIPPET', snippetId],
};
